import { isPlainObject } from "lodash-es";
import { getDeviceId } from "./helpers";

export function getDemoLocations(demoMessages) {
  if (!Array.isArray(demoMessages)) throw new Error(`Expected array of messages`);
  const locations = {};
  let total = 0;
  for (const msg of demoMessages) {
    const { payload } = msg;
    if (!isPlainObject(payload)) continue;
    const deviceId = msg.deviceId || getDeviceId(payload);
    if (!deviceId) continue;
    if (isPlainObject(payload.location)) {
      const locMeta = { ...payload.location };
      locMeta.timestamp = locMeta.timestamp || msg.timestamp;
      locMeta.eventType = payload.helpCode || msg.name;
      if (!(deviceId in locations)) locations[deviceId] = [];
      locations[deviceId].push(locMeta);
      total++;
    }
  }
  return { locations, total };
}
